<template>
  <tr>
    <td class="small">
      <b-form-checkbox
        v-if="data.support_update === true"
        v-model="selected"
        v-on:change="toggle"
      ></b-form-checkbox>
    </td>
    <td>
      {{ data.translated_name}}
    </td>
    <td v-if="showColumn('type')">
      {{ data.type }}
    </td>
    <td v-if="showColumn('sitecount')" class="text-center">
        <b-button variant="link" v-b-modal="`${modalId}`">
          {{ data.sitecount }}&nbsp;
          <span v-if="data.sitecount === 1">
            {{ $t("extensions.site") }}
          </span>
          <span v-else>
            {{ $t("extensions.sites") }}
          </span>
        </b-button>

        <b-modal
          :id="`${modalId}`" hide-footer
          title="Extension installed on sites"
        >
          <p v-html="siteInfo"></p>
        </b-modal>
    </td>
    <td v-if="showColumn('support_update')" class="text-center">
      <span v-if="data.support_update === true" class="pill pill--success">
        {{ $t("extensions.supportupdaterpositive") }}
      </span>
      <span v-if="data.support_update === false" class="pill pill--danger">
        {{ $t("extensions.supportupdaternegative") }}
      </span>
    </td>
    <td v-if="showColumn('auto_update')" class="small text-center">
      <b-form-checkbox
        v-if="data.support_update === true"
        v-model="enabled"
        class="bmswitch"
        v-on:change="toggleAutoupdate"
      ></b-form-checkbox>
    </td>
  </tr>
</template>

<script>
import { mapActions, mapGetters, mapMutations, mapState } from 'vuex'

export default {

  name: 'ExtensionItem',

  props: [
    'id',
    'data'
  ],

  computed: {
    ...mapState('extensions', {
      extensionSelected: state => state.selected
    }),

    ...mapGetters('local', ['getExtensionsColumns']),

    selected: {
      get () {
        return this.extensionSelected.includes(this.id)
      },
      set (value) {
        // just do nothing
      }
    },

    enabled: {
      get () {
        return this.data.autoupdate_enabled === 1
      },
      set (value) {
        // just do nothing
      }
    },

    siteInfo: {
      get () {
        return this.data.site_info.join('<br>')
      },
      set (value) {
        // just do nothing
      }
    },

    modalId () {
      return 'modal-sitextensions-' + this.id
    }
  },

  methods: {
    ...mapActions('extensions', [
      'autoUpdateChange'
    ]),

    ...mapMutations('extensions', [
      'addSelection',
      'removeSelection'
    ]),

    toggle (e) {
      if (e) {
        this.addSelection(this.data.id)
      } else {
        this.removeSelection(this.data.id)
      }
    },

    toggleAutoupdate () {
      const value = this.data.autoupdate_enabled === 0 ? 1 : 0

      let payload = {
        type: this.data.type,
        element: this.data.element,
        folder: this.data.folder,
        autoupdate: value
      }

      this.autoUpdateChange(payload)
    },

    showColumn (name) {
      return this.getExtensionsColumns.indexOf(name) !== -1
    }
  }
}
</script>
